export default __webpack_public_path__ + "4117a7d73844d056109064bd8454a5ed.svg";